import { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import UserClassStoryPast from './UserClassStoryPast'
import UserClassStoryPlanned from './UserClassStoryPlanned'

class UserClassStory extends Component {
  render() {
    const { archive, planned, fetchPastEvents, cancelEventParticipation, t } = this.props
    return (
      <div className="ctp-userclass-story">
        {archive.length === 0 && planned.length === 0 && (
          <small className="help">{t('user-panel:classes.notFoundSmall')}</small>
        )}
        <div className="columns">
          <div className="column is-4">
            <p>{t('user-panel:classes.historyOfAttendance')}</p>
            <UserClassStoryPast archive={archive} fetchPastEvents={fetchPastEvents} />
          </div>
          {planned.length > 0 && (
            <div className="column is-8">
              <p>{t('user-panel:classes.plannedClass')}</p>
              <UserClassStoryPlanned
                classes={planned}
                cancelEventParticipation={cancelEventParticipation}
              />
            </div>
          )}
        </div>
      </div>
    )
  }
}

UserClassStory.propTypes = {
  archive: PropTypes.object,
  planned: PropTypes.array,
  fetchPastEvents: PropTypes.func,
  cancelEventParticipation: PropTypes.func,
  t: PropTypes.func,
}

export default withTranslation(['user-panel'])(UserClassStory)
